import { __assign } from '../../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { Menu } from '@cheetahdigital/console-kit-cx';

var MenuItem = function (_a) {
    var children = _a.children, isDisabled = _a.isDisabled;
    return (jsx(Menu.Item, __assign({ size: "large", isDisabled: isDisabled }, { children: children }), void 0));
};

export { MenuItem as default };
